import { useState, useEffect } from "react";
import { useInterval } from "@mantine/hooks";
import { Modal, Text, Group, Button } from "@mantine/core";

export function UpdatePopup() {
  const interval = useInterval(() => {
    navigator.serviceWorker.getRegistrations().then((regs) =>
      regs.forEach((reg) => {
        reg.update();
      })
    );
  }, 1000 * 60 * 15);
  // }, 1000);

  const [opened, setOpened] = useState(false);

  useEffect(() => {
    interval.start();
    window.isUpdateAvailable?.then(
      (availableRegistration: ServiceWorkerRegistration) => {
        if (availableRegistration) {
          interval.stop();
          // setOpened(true);
          updateNRaload();
        }
      }
    );

    return interval.stop;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [null]);
  async function updateNRaload() {
    await navigator.serviceWorker.getRegistrations().then((regs) => {
      regs.forEach((reg) => reg.waiting?.postMessage({ type: "SKIP_WAITING" }));
      setTimeout(() => window.location.reload(), 1000);
    });
  }

  return (
    <Modal
      opened={opened}
      onClose={() => setOpened(false)}
      withCloseButton={false}
      overlayBlur={3}
      title="Eigenphi Update available!"
    >
      <Text mb="lg">
        A new version of the EigenPhi.io application is available. Please reload
        now.
      </Text>
      <Group position="apart">
        <Button variant="default" onClick={() => setOpened(false)}>
          Update later
        </Button>
        <Button onClick={() => updateNRaload()} data-autofocus>
          Reload
        </Button>
      </Group>
    </Modal>
  );
}
